// extracted by mini-css-extract-plugin
module.exports = {"menuContainer":"MobileMenu_menuContainer__2vhhB","menuLink":"MobileMenu_menuLink__-gCof"};